/**
 * Created by Tiger on 26/02/2022.
 */

export const HttpURLS = {
  REFRESH_CONFIG_LIST: '/v1/private/config',   //获取配置列表
  REFRESH_AL_HOST_LIST: '/v1/private/aliRegion', //阿里可用区域增加
  EDIT_CONFIG: '/v1/private/config', //配置
  DEVICE_URL: '/v1/private/devices',   //设备
  REFRESH_PRODUCTS_LIST: '/v1/private/products', //获取支持产品列表
};